module.exports = __webpack_public_path__ + "img/infoqMeeting-intro-h5.5d977657.png";